import { Typography } from "@mui/material";
import React from "react";
import { FacebookOutlined } from "@mui/icons-material";
import { Instagram } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { Stack, useMediaQuery } from "@mui/system";

import inno from "../../assets/innoAlRe/7.JPG";
import barbiere from "../../assets/barbiere/detail.png";
import osteria from "../../assets/osteria/1.JPG";
import molinare from "../../assets/molinara/room9.JPG";
import matri from "../../assets/matrimonio/1.JPG";
// Component for the Follow Us section
const FollowBox = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const icons = [
    {
      IconComponent: FacebookOutlined,
      link: "https://maps.google.com/?q=Via+Concezione+a+Montecalvario,+48,+80134+Napoli+NA,+Italia",
    },
    {
      IconComponent: Instagram,
      link: "/booking", // Route interna per la pagina di prenotazione
    },
  ];
  return (
    <div style={styles.followBox}>
      <div style={styles.followUs}>
        <Typography variant="h6" style={styles.title}>
          Follow Us
        </Typography>

        <Stack
          zIndex={9999999}
          sx={{
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "auto",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {icons.map((icon, index) => {
            const IconComponent = icon.IconComponent;
            return (
              <Link
                key={index}
                to={icon.link}
                style={{ textDecoration: "none" }}
              >
                <div
                  style={{
                    pointerEvents: "auto",
                    cursor: "pointer",
                    width: "40px",
                    height: "40px",
                    zIndex: 9999999999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50px",
                  }}
                >
                  <IconComponent sx={{ color: "black" }} />
                </div>
              </Link>
            );
          })}
        </Stack>
      </div>

      <div
        style={{
          ...styles.photos,
          display: isMobile ? "flex" : "none",
        }}
      >
        <img src={inno} alt="Inno Al Re" style={styles.photo} />
        <img src={matri} alt="Matrimonio Inaspettato" style={styles.photo} />
        <img
          src={barbiere}
          alt="Il Barbiere di Siviglia"
          style={styles.photo}
        />
        <img src={osteria} alt="L'Osteria di Marechiaro" style={styles.photo} />
        <img src={molinare} alt="La Molinara" style={styles.photo} />
      </div>
    </div>
  );
};

// Styles
const styles = {
  followBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
  },
  followUs: {
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    marginBottom: "10px",
  },
  icons: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
  },
  icon: {
    width: "40px",
    height: "40px",
    cursor: "pointer",
  },
  photos: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
  },
  photo: {
    width: "calc(20% - 10px)", // Ogni immagine occupa il 20% dello spazio meno il gap
    aspectRatio: "1/1", // Rende le immagini quadrate
    objectFit: "cover",
  },
};

export default FollowBox;
